import { render } from "./BaseDropdown.vue?vue&type=template&id=263a3e8a&scoped=true"
import script from "./BaseDropdown.vue?vue&type=script&lang=js"
export * from "./BaseDropdown.vue?vue&type=script&lang=js"

import "./BaseDropdown.vue?vue&type=style&index=0&id=263a3e8a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-263a3e8a"]])

export default __exports__